"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BlockedDomainsOption_1 = require("owa-blocked-domains-option/lib/BlockedDomainsOption");
var BlockedSendersOption_1 = require("owa-blocked-senders-option/lib/BlockedSendersOption");
var owa_junkmail_configuration_1 = require("owa-junkmail-configuration");
var owa_trace_1 = require("owa-trace");
var blockAllowSubCategory = {
    key: 'blockAllow',
    titleStringKey: 'optionSubcategory_junkEmail',
    options: [BlockedSendersOption_1.default, BlockedDomainsOption_1.default],
    onSelected: function () {
        return loadMailboxJunkEmailConfiguration();
    },
};
exports.default = blockAllowSubCategory;
function loadMailboxJunkEmailConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, owa_junkmail_configuration_1.initMailboxJunkEmailConfiguration()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    owa_trace_1.trace.warn(e_1.message || 'loadMailboxJunkEmailConfiguration failed');
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=blockAllowSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/blockAllowSubCategory.js
// module id = 5014
// module chunks = 2